import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from '../services/httpService';
import { LoginResponseModel } from '../models/loginResponseModel';
import { ConfigService } from '../services/configService';

@Injectable()
export class AuthenticationService {
    private baseUrl: string;

    constructor(
        private http: HttpService,
        private config: ConfigService,
    ) {
        this.baseUrl = this.config.get('apiUrl') + '/v1/login';
    }

    public login(email: string, password: string): Observable<LoginResponseModel> {
        return this.http.post(this.baseUrl, { email, password });
    }
}
